import { DomainDashboardDataGetters } from 'domain/shared/core/dashboard';
import { DashboardProject, getProjectManager } from 'domain/shared/newProject';

const projectDataGetters: DomainDashboardDataGetters<DashboardProject> = {
  people: (project: DashboardProject) => {
    const people = [];
    const projectManager = getProjectManager(project);

    if (projectManager) {
      people.push({
        id: projectManager,
        name: project.projectManagerName || projectManager,
        role: 'Project Manager',
      });
    }

    if (project?.accountData?.ownerAlias) {
      people.push({
        id: project.accountData.ownerAlias,
        name: project.accountManagerName || project.accountData.ownerAlias,
        role: 'Account Manager',
      });
    }

    const uniquePeople = people.filter(
      (person, index, self) => index === self.findIndex(p => p.id === person.id && p.role === person.role),
    );

    return uniquePeople;
  },
};

export default projectDataGetters;
